import { pick } from '../i18n.js';

export const usageText = pick({
  zh: {
    title: '账号用量', loading: '正在读取用量…', unavailable: '暂时无法读取用量，请稍后重新打开。',
    tokens: '总 token', calls: '模型调用', input: '输入', output: '输出', cacheRead: '缓存读取', cacheWrite: '缓存写入',
    cost: '目录费率估算（USD）', basis: '按已记录的目录费率估算，不是实际扣款。',
    coverage: '包含已记录的主对话、worker 与画布操作；不含其他辅助模型调用及旧系统会话。',
    empty: '暂无已记录的模型调用。', missing: '次调用缺少费用记录，未计入估算。',
    period: '记录范围', asOf: '统计时间', label: (name: string) => `账号用量：${name}`,
  },
  en: {
    title: 'Account usage', loading: 'Loading usage…', unavailable: 'Usage is unavailable. Reopen to retry.',
    tokens: 'Total tokens', calls: 'Model calls', input: 'Input', output: 'Output', cacheRead: 'Cache read', cacheWrite: 'Cache write',
    cost: 'Catalog-rate estimate (USD)', basis: 'Estimated from recorded catalog rates, not actual charges.',
    coverage: 'Includes recorded main conversations, workers and canvas operations; excludes other auxiliary model calls and legacy conversations.',
    empty: 'No recorded model calls yet.', missing: 'calls have no cost record and are excluded from the estimate.',
    period: 'Record range', asOf: 'As of', label: (name: string) => `Account usage: ${name}`,
  },
});
